module.exports = __webpack_public_path__ + "static/media/show_01.58cc4c48.svg";